import {
	AppConfigService,
	CLIENT_FEATURE_REFERENCE_CODES,
	ClientService,
	constants,
	FEATURE_FLAGS,
	NotificationAlertIndicatorService,
	ParticipantUtilityService
} from '@edassist/common';
import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { interval, Subscription } from 'rxjs';
import { AuthenticationService, NotificationService } from '@edassist/api';
import { distinctUntilChanged, shareReplay, startWith, switchMap } from 'rxjs/operators';

@Component({
	selector: 'tu-navbar-top-header',
	templateUrl: './tuition-navbar-top-header.component.html',
	styleUrls: ['./tuition-navbar-top-header.component.scss']
})
export class NavbarTopHeaderComponent implements OnInit, OnDestroy {
	@Input() productName: string;
	isLoggedIn: boolean;
	isNewNavigationBarEnabled = false;
	constants = constants;
	participantId: number;
	isNotificationsEnabled = true;
	enableNotificationPolling = true;
	notificationPollingTime = 300000;
	private count: number;

	private readonly subscriptions = new Subscription();
	constructor(
		private readonly authService: AuthenticationService,
		private readonly notificationService: NotificationService,
		protected readonly clientService: ClientService,
		private readonly notificationAlertIndicatorService: NotificationAlertIndicatorService
	) {}

	ngOnInit(): void {
		this.participantId = ParticipantUtilityService.getParticipantId();
		this.isNewNavigationBarEnabled = AppConfigService.isFeatureFlagEnabled(
			FEATURE_FLAGS.NEW_NAVIGATION_BAR_ENABLED
		);
		this.isNotificationsEnabled = AppConfigService.isFeatureFlagEnabled(
			FEATURE_FLAGS.NOTIFICATIONS_ENABLED
		);
		this.enableNotificationPolling = AppConfigService.isFeatureFlagEnabled(
			FEATURE_FLAGS.NOTIFICATIONS_POLLING_ENABLED
		);
		this.notificationPollingTime =
			this.enableNotificationPolling ?
				AppConfigService.getSettings().featureFlags?.notificationsPollingTime
			:	this.notificationPollingTime;
		this.subscriptions.add(
			this.authService.currentUser.subscribe((user) => {
				this.isLoggedIn = user?.sessionToken?.length > 0;
			})
		);

		if (
			this.isNotificationsEnabled &&
			this.enableNotificationPolling &&
			this.isNewNavigationBarEnabled
		) {
			if (
				this.clientService.isClientFeatureEnabled(
					CLIENT_FEATURE_REFERENCE_CODES.SITE_REDESIGN
				)
			) {
				interval(this.notificationPollingTime)
					.pipe(
						startWith(0),
						switchMap(() =>
							this.notificationService.getParticipantUnreadNotificationEventCount(
								this.participantId
							)
						),
						distinctUntilChanged(),
						shareReplay(1)
					)
					.subscribe((data) => {
						if (data && data !== this.count) {
							this.count = data;
							this.notificationAlertIndicatorService.notifyUnreadNotificationCount(
								data
							);
						}
					});
			}
		}
	}

	ngOnDestroy(): void {
		this.subscriptions.unsubscribe();
	}
}
